import React from 'react';

import SharedShow from 'shared/components/InsuranceRejections/Show';

const Show = _props => <SharedShow apiPrefix="/agent_portal/api/providers/" />;

export default Show;
